import { createContext, useContext } from 'react';
import { IGetCartItems, IIGetCartItemsRsponse } from '../../typescript/interfaces/cart-item.interface';
import { UseQueryResult } from '@tanstack/react-query';
import { IBaseResponse } from '../../typescript/interfaces/common.interface';
import CartContextProvider from './CartContextProvider';

type TCartContext = UseQueryResult<IIGetCartItemsRsponse, Error>;

const CartContext = createContext<Partial<TCartContext>>({});

const useCartContext = () => useContext(CartContext);

export { CartContext, useCartContext, CartContextProvider };
